(function(){
	document.addEventListener('DOMContentLoaded', ()=>{
		window.rw.bankUtils = {};
	});
// eslint-disable-next-line no-undef
})(jQuery);
